import { createAllCompanyAgreementSeeds } from 'app/src/msw/companyagreement/initialSeed'
import { createFamilyMembersSeed } from 'app/src/msw/membership/initialSeed/familyMembers'
import { createMembershipSeed } from 'app/src/msw/membership/initialSeed/membership'
import { createUserInfoSeed } from 'app/src/msw/membership/initialSeed/userInfo'
import { createWelfareCampaignSeed } from 'app/src/msw/membership/initialSeed/welfareCampign'
import { createTransferSeed } from 'app/src/msw/moneytransfer/initialSeed/transfers'
import { createRefundSeed } from 'app/src/msw/refund/initialSeed/refund'
import { createCreditSeed } from 'app/src/msw/shopping/initialSeed/credit'
import { createOrdersSeeds } from 'app/src/msw/shopping/initialSeed/orders'
import { WebAppContextProvider } from 'app/src/shared/helpers'
import { ProgressSpinner } from 'primereact/progressspinner'
import { useEffect, useState } from 'react'
import { enableMocking } from './setup'

export function WebAppContextByServiceWorker(props: React.PropsWithChildren) {
  const [registered, setRegistered] = useState(false)

  useEffect(() => {
    if (registered) return

    enableMocking().then(async () => {
      // Estrai i parametri dalla QueryString per la demo (usati solo al primo seed)
      const searchParams = window.location.hash.includes('?')
        ? window.location.hash.split('?')[1]
        : window.location.search.substring(1)
      const urlParams = new URLSearchParams(searchParams)
      const firstName = urlParams.get('firstName') || undefined
      const lastName = urlParams.get('lastName') || undefined
      const email = urlParams.get('email') || undefined
      const onlyDiscount = urlParams.get('onlyDiscount') === 'true'
      const onlyCatalog = urlParams.get('onlyCatalog') === 'true'
      const onlyPlus = urlParams.get('onlyPlus') === 'true'

      await createUserInfoSeed({ firstName, lastName, email, onlyDiscount, onlyCatalog, onlyPlus })
      await createWelfareCampaignSeed({ onlyDiscount, onlyCatalog, onlyPlus })
      await createFamilyMembersSeed()
      await createMembershipSeed({ firstName, lastName, email })
      await createFamilyMembersSeed()
      await createAllCompanyAgreementSeeds()
      await createRefundSeed({ firstName, lastName, email })
      await createTransferSeed({ firstName, lastName, email })
      await createOrdersSeeds({ firstName, lastName, email })
      await createCreditSeed()

      console.log('MSW: Service Worker registered')

      setRegistered(true)
    })
  }, [registered])

  return registered ? (
    <WebAppContextProvider>{props.children}</WebAppContextProvider>
  ) : (
    <div className='flex'>
      <div className='mx-auto mt-20'>
        <ProgressSpinner data-testid='loading-element' className='flex' />
      </div>
    </div>
  )
}
